var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "account" } },
    [
      !_vm.is_pub
        ? _c("div", { staticClass: "img-container" }, [
            _c("img", {
              attrs: {
                src: "/static/" + _vm.client_name + "/images/header/logo.png",
                alt: "客製化版本logo"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "info-container", attrs: { justify: "space-between" } },
        [
          _c("v-col", { attrs: { cols: "6" } }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("__acount.account")) +
                "：" +
                _vm._s(_vm.user) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("v-col", { attrs: { cols: "4" } }, [
            _c(
              "div",
              { staticClass: "logout-btn", on: { click: _vm.logout } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__navbar.logout")) +
                    "\n            "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "link-container" },
        [
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            _vm._l(_vm.user_customization, function(list, key) {
              return _c(
                "div",
                { key: key },
                [
                  _vm._l(list, function(item, idx) {
                    return _c(
                      "v-btn",
                      {
                        key: idx,
                        staticClass: "ma-1 link-btn",
                        style: "background-color:" + item.color + "a6;",
                        attrs: {
                          href: "/" + item.name + "/",
                          variant: "tonal",
                          rounded: "lg",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.c_name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _c("br")
                ],
                2
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }